import styled from 'styled-components';

interface ContainerProps {
  maxWidth?: string;
  padding?: string;
  margin?: string;
}

export const Container = styled.div<ContainerProps>`
  padding: ${props => props.padding || '0.5rem'};
  max-width: ${props => props.maxWidth || '1800px'};
  margin: ${props => props.margin || '0 auto'};
`;